/**
 * array version
 */

import { TicketType } from 'store/models/TicketTypeHelper';
import MatchHelper from './MatchHelper';
import { StatusI } from './Statuses';

export interface EachStatusDateTime {
  status: StatusI;
  ticketType: TicketType;
  latestUpdateDate: string | null;
}

export interface InboxesStatusLatestUpdateDateI {
  inboxes: string[];
  statusLatestUpdateDate: EachStatusDateTime[];
}

export declare type AllInboxesStatusLatestUpdateDateI = InboxesStatusLatestUpdateDateI[];

class AllInboxesStatusLatestUpdateDate {
  static getDefault(): AllInboxesStatusLatestUpdateDateI {
    return [];
  }

  /* non static */
  allInboxesStatusLatestUpdateDate: AllInboxesStatusLatestUpdateDateI;

  constructor(
    allInboxesStatusLatestUpdateDate: AllInboxesStatusLatestUpdateDateI,
  ) {
    this.allInboxesStatusLatestUpdateDate = allInboxesStatusLatestUpdateDate;
  }

  update(
    inboxes: string[],
    statusTicketTypeLatestUpdateDate: {
      [status: string]: { [ticketType: string]: string | null };
    },
    useUpdateOnly = false,
    returnModel = false,
  ):
    | AllInboxesStatusLatestUpdateDate
    | AllInboxesStatusLatestUpdateDateI {
    Object.entries(statusTicketTypeLatestUpdateDate).forEach(
      ([status, statusV]) => {
        Object.entries(statusV).forEach(
          ([ticketType, latestUpdateDate]) => {
            let statusLatestUpdateDate = {
              status: status as StatusI,
              ticketType: ticketType as TicketType,
              latestUpdateDate,
            };
            this._update(
              inboxes,
              statusLatestUpdateDate,
              returnModel,
            );
          },
        );
      },
    );
    // const before = this.allInboxesStatusLatestUpdateDate;
    // filter out those that are no in the statusTicketTypeLatestUpdateDate for the inboxes
    if (useUpdateOnly) {
      this.allInboxesStatusLatestUpdateDate = this.allInboxesStatusLatestUpdateDate.map(
        (item) => {
          if (
            MatchHelper.matchedExactInboxes(item.inboxes, inboxes)
          ) {
            return {
              ...item,
              // filter fot the updated only
              statusLatestUpdateDate: item.statusLatestUpdateDate.filter(
                (item2) =>
                  item2.status in statusTicketTypeLatestUpdateDate &&
                  item2.ticketType in
                    statusTicketTypeLatestUpdateDate[item2.status],
              ),
            };
          }
          return item;
        },
      );
    }
    // console.debug(`request update ticket`, {
    //   before,
    //   after: this.allInboxesStatusLatestUpdateDate,
    //   statusTicketTypeLatestUpdateDate,
    // });

    return returnModel
      ? (this as AllInboxesStatusLatestUpdateDate)
      : this.allInboxesStatusLatestUpdateDate;
  }

  _update(
    inboxes: string[],
    statusLatestUpdateDate: {
      status: StatusI;
      ticketType: TicketType;
      latestUpdateDate: string | null;
    },
    returnModel = false,
  ):
    | AllInboxesStatusLatestUpdateDate
    | AllInboxesStatusLatestUpdateDateI {
    const existed = this.allInboxesStatusLatestUpdateDate.some(
      (item) =>
        MatchHelper.matchedExactInboxes(item.inboxes, inboxes),
    );
    const newItem = statusLatestUpdateDate;
    const {
      status,
      ticketType,
      latestUpdateDate,
    } = statusLatestUpdateDate;
    let newAll;
    if (!existed) {
      newAll = this.allInboxesStatusLatestUpdateDate.concat({
        inboxes,
        statusLatestUpdateDate: [newItem],
      });
    } else {
      newAll = this.allInboxesStatusLatestUpdateDate.map((item) => {
        if (MatchHelper.matchedExactInboxes(item.inboxes, inboxes)) {
          const hasAny = item.statusLatestUpdateDate.some(
            (item) =>
              item.status === status &&
              item.ticketType === ticketType,
          );
          let newStatusLatestUpdateDate = item.statusLatestUpdateDate;
          if (hasAny) {
            newStatusLatestUpdateDate = newStatusLatestUpdateDate.map(
              (eachSDate) => {
                if (
                  eachSDate.status === status &&
                  eachSDate.ticketType === ticketType
                ) {
                  return {
                    ...eachSDate,
                    latestUpdateDate,
                  };
                }
                return eachSDate;
              },
            );
          } else {
            newStatusLatestUpdateDate = newStatusLatestUpdateDate.concat(
              newItem,
            );
          }

          return {
            inboxes,
            statusLatestUpdateDate: newStatusLatestUpdateDate,
          };
        }
        return item;
      });
    }
    this.allInboxesStatusLatestUpdateDate = newAll;
    return returnModel ? this : this.allInboxesStatusLatestUpdateDate;
  }

  getStatusLatestUpdateDate(
    inboxes: string[],
    related?: { [status: string]: TicketType[] },
  ): EachStatusDateTime[] {
    const pre =
      this.allInboxesStatusLatestUpdateDate.find((item) =>
        MatchHelper.matchedExactInboxes(item.inboxes, inboxes),
      )?.statusLatestUpdateDate ?? [];
    if (!related) return pre;
    let final;
    final = pre.filter(
      (item) =>
        item.status in related &&
        related[item.status].includes(item.ticketType),
    );
    return final;
  }
}

export { AllInboxesStatusLatestUpdateDate };
